import socket from '@/services/socket.js'

export default {
  /**
   * Create new named location.
   *
   * @param body
   * @returns Promise
   */
  create(params) {
    const action = '/named_location/add'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        body: params
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data.named_locations[0])
      })
    })
  },

  /**
   * Update named location.
   *
   * @param named_location_id
   * @param group_id
   * @param body
   * @returns Promise
   */
  update(named_location_id, group_id, params) {
    const action = '/named_location/update'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        named_location_id,
        group_id,
        body: params
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data.named_locations[0])
      })
    })
  },

  /**
   * Get named location by id.
   *
   * @param named_location_id
   * @param group_id
   * @returns Promise
   */
  get(named_location_id, group_id) {
    const action = '/named_location/get'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        named_location_id,
        group_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        if (data.named_locations && data.named_locations.length) {
          resolve(data.named_locations[0])
        }

        resolve(null)
      })
    })
  },

  /**
   * Get all named locations by group id.
   * 
   * @param group_id
   * @returns Promise
   */
  getAll(group_id) {
    const action = '/named_location/get/by_group_id'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        group_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  },

  /**
   * Delete named location.
   *
   * @param named_location_id
   * @param group_id
   * @returns Promise
   */
  delete(named_location_id, group_id) {
    const action = '/named_location/delete'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        named_location_id,
        group_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  },

  /**
   * Add children alert settings.
   *
   * @param group_id
   * @param named_location_id
   * @param alert_settings
   * @returns Promise
   */
  setAlertSettings(named_location_id, group_id, alert_settings) {
    const action = '/named_location/alert_setting'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        group_id,
        named_location_id,
        alert_settings
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  },

  getLocationHistory(user_id, page_size = 50, max_date = new Date()) {
    const action = '/user/location_history/get'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id,
        max_date,
        page_size
      }, (error, data) => {
        error ? reject(new Error(error)) : resolve(data)
      })
    })
  }
}